export default __webpack_public_path__ + "static/media/animation_error.942922e4.gif";